import React from 'react';
import { Navbar, Nav, Container, Row, Col } from 'react-bootstrap';
import { JSignOut, KnownUser } from './auth';
import { useAuthenticator } from '@aws-amplify/ui-react';
import logo from '../components/assets/Logo Reha-AHB-Prävention.png';
import { istMitarbeiter, istAdmin, verifiedUser } from '../components/utils';

const Items = ({ user }) => {
  const isVerifiedUser = verifiedUser(user);
  const showInformation = !!user;
  const showUploads = istAdmin(user);

  return (
    <>
      {isVerifiedUser && <Nav.Link href="#/menues">Menüwahl</Nav.Link>}
      {isVerifiedUser && !istMitarbeiter(user) && <Nav.Link href="#/anamnese">Anamnesebogen</Nav.Link>}
      {isVerifiedUser && !istMitarbeiter(user) && <Nav.Link href="#/rehaziele">Rehaziele</Nav.Link>}
      {isVerifiedUser && !istMitarbeiter(user) && <Nav.Link href="#/einverstaendnis">Einverständniserklärungen</Nav.Link>}
      {isVerifiedUser && !istMitarbeiter(user) && <Nav.Link href="#/screening">Würzburger Screening</Nav.Link>}
      {isVerifiedUser && showInformation && <Nav.Link href="#/information">Informationen</Nav.Link>}
      {isVerifiedUser && showUploads && <Nav.Link href="#/uploads">Hochladen</Nav.Link>}
      {user && <Nav.Link href="#/profile">Profil</Nav.Link>}
      <Nav.Link href="#/impressum">Impressum</Nav.Link>
    </>
  );
};

const LoginItem = () => (
  <a href="#/login" style={{ textDecoration: 'underline' }}>Anmeldung</a>
);

const Navigator = () => {
  const { user, signOut } = useAuthenticator((context) => [context.user]);

  return (
    <div style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1000 }}>
      {/* Zeile 1: Logo + User */}
      <Container fluid className="py-2">
        <Row className="align-items-center justify-content-between">
          <Col xs="auto">
            <a href="#">
              <img src={logo} alt="Kliniken Dr. Vötisch GmbH" width="226" height="80" />
            </a>
          </Col>
          <Col xs="auto">
            {user ? (
              <>
                <KnownUser user={user} /> &nbsp; <JSignOut signOut={signOut} />
              </>
            ) : (
              <LoginItem />
            )}
          </Col>
        </Row>
      </Container>

      {/* Zeile 2: Navigation */}
      <Navbar bg="white" expand="lg">
        <Container fluid>
          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="me-auto">
              <Items user={user} />
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div style={{
        height: '8px',
        width: '100%',
        background: 'linear-gradient(to bottom, #b8b8b8, white)'
      }} />
    </div>
  );
};

export default Navigator;
